import { render, staticRenderFns } from "./HeaderControlsProject.vue?vue&type=template&id=2383fb20&"
import script from "./HeaderControlsProject.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsProject.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2383fb20')) {
      api.createRecord('2383fb20', component.options)
    } else {
      api.reload('2383fb20', component.options)
    }
    module.hot.accept("./HeaderControlsProject.vue?vue&type=template&id=2383fb20&", function () {
      api.rerender('2383fb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControlsProject.vue"
export default component.exports